import React from 'react'
import {KsLogo} from '../../../components/icons'
import {Box, Image} from '@chakra-ui/react'
import {getUrl} from '../../../utils/cloudinary-utils'
const CbDesktopSpinner = () => {
    return (
        <Box gap="48px" display={{base: 'none', lg: 'grid'}} margin="60px">
            <Image
                src={getUrl('UIImages/images/colorbar-by-ks.svg')}
                maxWidth="579px"
                margin="auto"
                width="100%"
                height="100px"
                alt="Color Bar by Kendra Scott"
            />
            <Box
                sx={{
                    display: 'inline-block',
                    transformOrigin: '50% 50%',
                    width: '100px',
                    height: '100px',
                    margin: 'auto',
                    animation: 'dingDongDesktop 4s ease-in-out infinite' // slowed down
                }}
            >
                <KsLogo width="100px" height="100px" alt="Kendra Scott Logo" />
                <style>
                    {`
                    @keyframes dingDongDesktop {
                        0%   { transform: rotate(0deg); }
                        50%  { transform: rotate(179deg); }
                        100% { transform: rotate(0deg); }
                    }
                `}
                </style>
            </Box>
            <Image
                src={getUrl('UIImages/images/colorbar-stage.svg')}
                maxWidth="1064px"
                margin="auto"
                width="100%"
                height="80.87px"
                alt="Color Bar Stage"
            />
        </Box>
    )
}

export default CbDesktopSpinner
